import React from "react";

// eslint-disable-next-line import/no-anonymous-default-export
export default (params) => {
    const value = params?.value;
    return <div className={"icon-align"}>
        {Array.isArray(value) ?
            value.map((val, ind) => (
                <span className={ind === 0 ? '' : 'ms-3'} onClick={(event) => {
                    event.preventDefault();
                    val?.onClick();
                }}
                    style={{ cursor: val?.onClick ? 'pointer' : 'default' }}
                >
                    <i className={val?.class} title={val?.title} />
                </span>
            ))
            :
            <span onClick={(event) => {
                event.preventDefault();
                value?.onClick();
            }}
                style={{ cursor: value?.onClick ? 'pointer' : 'default' }}
            >
                {
                    Array.isArray(value) ? value.map(val => <i className={val?.class} title={val?.title} />) : (<div className={`${value?.data ? "icon_center" : ''}`}>
                        <i className={`${value?.class} ${value?.blink ? 'blink_me' : ''}`} title={value?.title} />
                        {value?.data ? <span style={{ marginTop: '-0.75rem' }}>{value?.data}</span> : ''}
                        {value?.rightSideText ? <span>{value?.rightSideText}</span> : ''}
                    </div>)
                }
            </span>
        }

    </div>
}
